import AsahiAccessLogRepository from './AsahiAccessLogRepository';
import ChapterSlideRepository from './ChapterSlideRepository';
import ChapterVideoLogRepository from './ChapterVideoLogRepository';
import CompanyChapterSlideRepository from './CompanyChapterSlideRepository';
import CompanyChapterVideoLogRepository from './CompanyChapterVideoLogRepository';
import FavoriteRepository from './FavoriteRepository';
import UserAgreementRepository from './UserAgreementRepository';

function getRepositories() {
  const repositories = {
    companyChapterSlide: new CompanyChapterSlideRepository(),
    chapterSlide: new ChapterSlideRepository(),
    companyChapterVideoLog: new CompanyChapterVideoLogRepository(),
    chapterVideoLog: new ChapterVideoLogRepository(),
    favoriteRepository: new FavoriteRepository(),
    asahiAccessLogRepository: new AsahiAccessLogRepository(),
    userAgreementRepository: new UserAgreementRepository(),
  };
  return repositories;
}

export default getRepositories();
